module.exports = {
  Bar: require('./lib/bar'),
  Bubble: require('./lib/bubble'),
  Doughnut: require('./lib/doughnut'),
  Line: require('./lib/line'),
  Pie: require('./lib/pie'),
  PolarArea: require('./lib/polar-area'),
  Radar: require('./lib/radar'),
  Scatter: require('./lib/scatter'),
  createClass: require('./lib/core').createClass
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/react-chartjs/index.js
 ** module id = 816
 ** module chunks = 2
 **/